export default __webpack_public_path__ + "static/media/TemplateTwo.e33190ef.jpeg";